/*eslint-disable*/
export const englishAndRussian = {
    '1': 0.8,
    '2': 1,
    '3': 1.8,
    '4': 3.5,
    '5': 5
};
export const bulgarian = {
    '1': 1,
    '2': 2,
    '3': 3
};
export const ukrainian = {
    '1': 1.3,
    '2': 2.6,
    '3': 2.7
};
export const french = {
    '1': 2,
    '2': 3,
    '3': 3.2
};
export const latvian = {
    '1': 1.2,
    '2': 2,
    '3': 3,
};

export const spanish = {
    '1': 0.8,
    '2': 1,
    '3': 1.8,
};
